import { createFileRoute } from "@tanstack/react-router"
import { Wrapper } from "./-ImageEditIdPage"

export const Route = createFileRoute("/prototypes/image-editor/$imageEditId")({ component: Wrapper })
